import { render } from "./ContactPage.vue?vue&type=template&id=4e61c116&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=4e61c116&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e61c116"

export default script